import { render, staticRenderFns } from "./MovieSoundtrackSourcesModal.vue?vue&type=template&id=1fe505cb&"
import script from "./MovieSoundtrackSourcesModal.vue?vue&type=script&lang=js&"
export * from "./MovieSoundtrackSourcesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports